<template>
    <v-container class="pa-2" fluid grid-list-sm > 
        <MainContent v-bind:type_object='"chapter"' />
    </v-container>
</template>

<script>
    import MainContent from '../content/main_content.vue'

    export default {
        components: {
            MainContent
        },
    }
</script>